import { useBreakpoints } from '@/Utility/hooks';
import { GridView, ViewList } from '@mui/icons-material';
import { Stack, type StackProps, ToggleButton, ToggleButtonGroup } from '@mui/material';
import CsvExport from './CsvExport';
import SelectActions from './SelectActions';

type Props = {
  hasTableProps: boolean;
  hasGridSelectView: boolean;
  view: 'grid' | 'list';
  setView: (view: Props['view']) => void;
  slotProps?: {
    root?: StackProps;
  };
};

const ActionBar = ({ hasGridSelectView, hasTableProps, view, setView, slotProps }: Props) => {
  const { isMobile } = useBreakpoints();

  return (
    <Stack
      className="multiViewPicker-actionbar"
      gap={0.5}
      direction="row"
      justifyContent="space-between"
      {...slotProps?.root}
      sx={{
        height: '45px',
        mb: 1,
        position: 'sticky',
        top: '56px',
        zIndex: '12',
        backgroundColor: 'white',
        ...slotProps?.root?.sx,
      }}
    >
      <Stack direction="row" gap={0.5}>
        {!hasGridSelectView ? <SelectActions view={view} /> : null}
      </Stack>

      <Stack direction="row" gap={0.5}>
        <CsvExport />
        {/* Only show toggle on non-mobile screen sizes */}
        {!!hasTableProps && !hasGridSelectView && !isMobile && (
          <ToggleButtonGroup
            className="multiViewPicker-toggle"
            value={view}
            exclusive
            onChange={(e, value: Props['view'] | null) => {
              if (!value) return;
              setView(value);
            }}
          >
            <ToggleButton disableRipple value="grid" aria-label="grid" className="multiViewPicker-button">
              <GridView style={{ fontSize: '15px' }} />
            </ToggleButton>
            <ToggleButton disableRipple value="list" aria-label="list" className="multiViewPicker-button">
              <ViewList style={{ fontSize: '15px' }} />
            </ToggleButton>
          </ToggleButtonGroup>
        )}
      </Stack>
    </Stack>
  );
};

export type { Props as ActionBarProps };

export default ActionBar;
